import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  bestSellerOne,
  bestSellerFour,
  bestSellerFive,
  bestSellerSix,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Top Export Fruits and Vegetables from India" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">

        <Product
          _id="1011"
          img={bestSellerOne}
          productName="Fresh Red Tomatoes"
          price="4.00"
          color="Red"
          badge={true}
          size="30 mm, 50 mm, 55 mm"
          packaging="5 kg, 10 kg, 15 kg Carton Box"
          des="Premium quality Fresh Red Tomatoes exported from India. Ideal for international markets including Sri Lanka, Maldives, Oman, South Africa, and other countries worldwide. Rich in flavor, perfect for culinary and processing uses."
        />

        <Product
          _id="1012"
          img={bestSellerFour}
          productName="Fresh Green Chillies"
          price="3.70"
          color="Green"
          badge={false}
          size="5 to 10 cm"
          packaging="3 kg to 5 kg Carton Box"
          des="High-quality Fresh Green Chillies exported from India. Suitable for culinary use, spice production, and international trade to markets in Sri Lanka, Maldives, Oman, South Africa, and beyond."
        />

        <Product
          _id="1013"
          img={bestSellerFive}
          productName="Fresh Pomegranate"
          price="1.98"
          color="Dark Red"
          badge={false}
          size=""
          Weight="250 gm+ 400 gm"
          Taste="Sweet"
          Varieties="Bhagwa, Arkata, Ganesh"
          packaging="3 kg, 5 kg, 10 kg Carton Box"
          des="Export-quality Fresh Pomegranate from India. Main varieties include Bhagwa, Arkata, and Ganesh. Bhagwa variety is renowned for soft seeds, dark red color, and exceptional taste. Available for international trade to countries like Germany, UK, USA, Australia, Canada, and more."
        />

        <Product
          _id="1014"
          img={bestSellerSix}
          productName="Yellow Lemon"
          price="1.73"
          color="Yellow"
          badge={false}
          Varieties="Lisbon Lemons"
          size="30 mm and 40 mm"
          packaging="10 kg, 20 kg"
          des="High-quality Yellow Lisbon Lemons from India. Ideal for export markets, culinary applications, and juice production. Available globally for importers seeking fresh citrus products."
        />

      </div>
    </div>
  );
};

export default BestSellers;
